<!--
 * @Description: 钱帐通会员页面
 * @Author: gaohc
 * @Date: 2023-10-17 16:43:52
 * @LastEditTime: 2024-01-07 01:10:48
-->
<template>
  <div class="body">
    <el-row class="search-row-margin" :gutter="0" type="flex" justify="space-between">
      <el-col :span="8" style="text-align: left;">
        <span class="search-title-wrap">机构名称：</span>
        <el-select size="small" filterable v-model="filterParams.institutionId" clearable placeholder="请输入/选择" 
          :filter-method="interactionUtil.debounce((value) => commonUtil.handleListFilter(value, 'institutionList', srcInstitutionList, this))"
					@visible-change="(visible) => commonUtil.handleListFilterVisibleChange(visible, 'institutionList', srcInstitutionList, this)" 
          style="width: 190px;">
          <el-option v-for="item in institutionList"
            :key="item.id"
            :label="item.name"
            :value="item.id">
          </el-option>
        </el-select>
      </el-col>
      <el-col :span="8" style="text-align: left;">
        <span class="search-title-wrap">钱账通会员号：</span>
        <el-input size="small" style="width: 190px;" v-model="filterParams.lklMerchantNo" 
          clearable placeholder="请输入钱账通会员号">
        </el-input>
      </el-col>
      <el-col :span="8" style="text-align: right;">
        <el-button size="small" @click="handleQuery" type="primary" icon="el-icon-search" 
          style="width: 80px; margin-right: 20px;">
          搜 索
        </el-button>
        <el-button v-if="merchantPrivilege && merchantPrivilege.canAdd" @click="handleApply" 
          size="small" type="primary" icon="el-icon-document-add" plain 
          style="width: 80px; background: #FEFFFF; color: #3E7EF5;">
          申 请
        </el-button>
        <el-tooltip v-else effect="light" content="一家机构只能申请一次" placement="top-start">
          <div style="display: inline-block;">
            <el-button size="small" type="info" icon="el-icon-document-add" disabled plain  
              style="width: 96px; color: #868686; background: #ECECEC;">
              申 请
            </el-button>        
          </div>
        </el-tooltip>        
      </el-col>      
    </el-row>
    <div class="main-page-divider"></div>
    <div class="merchant-list-content" v-if="showTable">
      <el-table class="table-common-style" :style="tableWidth" ref="table" :data="dataTable" 
        :header-cell-style="{ 'text-align': 'left', 'background-color': '#EFF5FA'}">
        <el-table-column label="申请机构" min-width="28%" align="left">
          <template slot-scope="scope">
            <span class="overflow-text-style">{{scope.row.institutionName}}</span>
          </template>
        </el-table-column>
        <el-table-column label="钱账通会员号" min-width="27%" align="left">
           <template slot-scope="scope">
            <span>{{scope.row.memberNo || '- -'}}</span>
          </template>
        </el-table-column>
        <el-table-column label="审核状态" min-width="20%" align="left">
          <template slot-scope="scope" >
            <el-popover v-if="scope.row.memberStatus == 10 
              || scope.row.memberStatus == 20" placement="bottom" 
              title="" width="250" trigger="hover" >
              <span>{{'拒绝原因: ' + scope.row.merchantReviewRemark}}</span>
              <span slot="reference" style="cursor: pointer;">
                {{scope.row.memberStatusTxt ? scope.row.memberStatusTxt : '- -'}}
              </span>
            </el-popover>
            <span v-else>
              {{scope.row.memberStatusTxt ? scope.row.memberStatusTxt : '- -'}}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="genTime" label="开通时间" min-width="25%" 
          sortable align="left">
          <template slot-scope="scope">
            <span>{{scope.row.genTime || '- -'}}</span>
          </template>
        </el-table-column>
      </el-table>
      <el-row class="foot-pagination">
        <el-pagination background @size-change="handleSizeChange" @current-change="handleCurPage" 
          :current-page="filterParams.page" :page-sizes="pageSizes" :page-size="filterParams.pageSize" 
          layout="total,prev, pager, next,sizes,jumper" :total="totalNumber" />
      </el-row>
    </div>
    <div class="merchant-apply" v-else>
      <el-image :src="require('@/assets/mchmng/img-mchmng-placeholder.png')" fit="cover" 
        style="width: 293px; height: 184px; margin-left: 6px;"></el-image>
      <div class="merchant-apply-des">
        <span>平台已开通钱账通，</span>
        <span style="color: #3A7FF3; font-size: 18px;" :style="{'cursor': merchantPrivilege && 
          merchantPrivilege.canAdd ? 'pointer' : ''}" @click="handleApply">
          点击申请钱账通会员
        </span>
        <span>，申请成功后机构收入方可提现</span>
      </div>
    </div>

    <!-- 选择申请机构弹框 -->
    <sel-apply-inst-dialog :visible="showSelApplyInstDialog" 
      @close-dialog="closeSelApplyInstDialog"/>

    <!-- 申请钱账通会员抽屉 -->
    <mch-apply-drawer :visible="showMchApplyDrawer"
      :currentInstData="currentInstData" :mode="'add'"
      @close-drawer="closeMchApplyDrawer"/>

  </div>
</template>

<script>
import Constant from '@/global/Constant.js'
import SelApplyInstDialog from './components/SelApplyInstDlg.vue'
import MchApplyDrawer from './components/ApplyMember.vue'

export default {
  name: 'MerchantList',
  components: {
    'sel-apply-inst-dialog': SelApplyInstDialog,
    'mch-apply-drawer': MchApplyDrawer,
  },

  data() {
    return {
      filterParams: {
        page: 1,
        pageSize: this.commonConst.PAGE_SIZE,
      },
      pageSizes: this.commonConst.PAGE_SIZES,
      totalNumber: 0,
      institutionList: [],
      srcInstitutionList: [],
      dataTable: [],
      showTable: false,//是否显示table表格(没有搜索条件且无数据显示占位图,其余情况显示table表格)
      currentInstData: {},//当前选择申请的机构数据
      
      //当前用户会员操作的权限数据
      merchantPrivilege: {}, 
      
      showSelApplyInstDialog: false,    //是否显示申请机构弹框
      showMchApplyDrawer: false,        //是否显示钱账通会员抽屉
      mode: '',                         //抽屉的模式     
    }
  },
  
  computed: {
    tableWidth() {
      return 'width:' + (this.$root.contentWidth - 80) + 'px';
    },
  },
  
  methods: {
    async initData() {
			await this.getFilterDo();
      await this.listMerchants();
    },

    getFilterDo() {
      return new Promise((resolve) => {
        this.appAxios("GET", Constant.URL_GET_LKL_MERCHANT_FILTER_DO).then(result => {
          if (result != null) {
						this.institutionList = result.data.institutionList;
      			this.srcInstitutionList = result.data.institutionList;
            this.merchantPrivilege.canAdd = result.data.canAdd;
            resolve();
          }
        })
      })
    },

    listMerchants() {
			return new Promise((resolve) => {
        let header = this.encryptionUtil.signatureParams(this.filterParams,
          Constant.SIGNATURE_KEY_NAME, Constant.SIGNATURE_KEY);
        let requestData = {
          method: 'GET',
          url: Constant.URL_PAGE_LKL_MERCHANTS,
          param: this.filterParams,
          header: header,
          contentType: this.commonConst.CNTYPE_URLENCODED,
        };
        this.vueRequest(requestData).then(result => {
          if (result != null) {
            if (!this.filterParams.institutionId && !this.filterParams.lklMerchantNo 
              && result.data.length == 0) {
              this.showTable = false;
            } else {
              this.showTable = true;
            }
						this.dataTable = result.data;
            this.totalNumber = result.totalNumber;
            resolve();
          }
        })
      })
    },
  
    //搜索
    handleQuery() {
      this.listMerchants();
    },

    //编辑
    handleEdit(data) {
      this.mode = "edit";
      this.currentInstData = {
        id: data.institutionId,
        name: data.institutionName
      };
      this.showMchApplyDrawer = true;
    },

    //申请
    handleApply() {
      this.showSelApplyInstDialog = true;
    },

    //关闭申请机构dialog
    closeSelApplyInstDialog(data) {
      this.showSelApplyInstDialog = false;
      if (data.refresh) {
        this.currentInstData = data.instItem;
        this.mode = "add";
        this.showMchApplyDrawer = true;
      }
    },

    //关闭钱账通会员抽屉
    closeMchApplyDrawer(_refresh) {
      this.showMchApplyDrawer = false;
      this.listMerchants();
    },

    //以下是分页控件操作
    handleSizeChange(val) {
      this.filterParams.pageSize = val;
      this.listMerchants();
    },

    handleCurPage(curPage) {
      this.filterParams.page = curPage;
      this.listMerchants();
    },
  },

  mounted() {
    this.$emit("breadcrumb", {text1: '机构管理', text2: '钱账通会员'});
    this.initData();
  }
}
</script>

<style scoped>
.body {
  margin: 0;
  text-align: center;
  border: solid 0px;
}

.merchant-apply {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 120px;
}

.merchant-apply-des {
  width: 380px;
  text-align: left;
  font-size: 14px;
  font-weight: 400;
  color: #666666;
  line-height: 20px;
  margin-top: 29px;
}

.overflow-text-style {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}
</style>


// WEBPACK FOOTER //
// src/components/memmng/MemberList.vue